import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './WsrDivider.st.css';
import { directions, skins } from './constants';
/** A component that separates content by a line horizontally or vertically */
class Divider extends React.PureComponent {
    render() {
        const { dataHook, className, direction, skin } = this.props;
        return (React.createElement("hr", { "data-hook": dataHook, className: st(classes.root, { direction, skin }, className) }));
    }
}
Divider.displayName = 'Divider';
Divider.propTypes = {
    dataHook: PropTypes.string,
    direction: PropTypes.oneOf(['horizontal', 'vertical']),
    skin: PropTypes.oneOf([
        'light',
        'dark',
        'standard',
        'warning',
        'destructive',
        'success',
        'premium',
    ]),
};
Divider.defaultProps = {
    direction: directions.horizontal,
    skin: skins.light,
};
export default Divider;
//# sourceMappingURL=Divider.js.map